import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';
import {LangContext} from "../../App";

const Nav = () => {
    const lang = useContext(LangContext)

    const content = {
        en: {
            privateTour: "Private Tours",
            group: "Group Tours",
            tour: "Tour Packages",
            lesser: "Lesser Armenia",
            hotels: "Hotels",
            about: "About Armenia",
            europe: "Europe Tours",
            restaurants: "Restaurants",
            apartments: "Apartments",
            embassies: "Embassies",
            news: "News",
            guideBook: "GuideBook",
        },
        de: {
            privateTour: "Private Touren",
            group: "Gruppentouren",
            tour: "Tourpakete",
            lesser: "Kleinarmenien",
            hotels: "Hotels",
            about: "Über Armenien",
            europe: "Europa-Touren",
            restaurants: "Restaurants",
            apartments: "Unterkünfte",
            embassies: "Botschaften",
            news: "Nachrichten",
            guideBook: "Reisehandbuch",
        },
    }

    const {privateTour, about, apartments, embassies, europe,
        group, tour, news, guideBook,
        hotels, lesser, restaurants} = content[lang] || content.en;

    return (
        <nav className='nav'>
            <Link to={`/${lang}/private-tours`}>{privateTour}</Link>
            <Link to={`/${lang}/group-tours`}>{group}</Link>
            <Link to={`/${lang}/packages`}>{tour}</Link>
            <Link to={`/${lang}/abroad`}>{lesser}</Link>
            <Link to={`/${lang}/hotels`}>{hotels}</Link>
            <Link to={`/${lang}/about-armenia`}>{about}</Link>
            <div className='nav-dropdown'>
                <FontAwesomeIcon icon={faBars} />
                <ul className='nav-dropdown-menu'>
                    <li>
                        <Link to={`/${lang}/other-tours`}>{europe}</Link>
                    </li>
                    <li>
                        <Link to={`/${lang}/restaurants`}>{restaurants}</Link>
                    </li>
                    <li>
                        <Link to={`/${lang}/apartment`}>{apartments}</Link>
                    </li>
                    <li>
                        <Link to={`/${lang}/embassies`}>{embassies}</Link>
                    </li>
                    <li>
                        <Link to={`/${lang}/news`}>{news}</Link>
                    </li>
                    <li>
                        <Link to={`/${lang}/guide`}>{guideBook}</Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Nav;